import { render } from "./InstrucoesCarregamentoPedidoEmAndamento.vue?vue&type=template&id=c48f9a2e&scoped=true"
import script from "./InstrucoesCarregamentoPedidoEmAndamento.vue?vue&type=script&lang=js"
export * from "./InstrucoesCarregamentoPedidoEmAndamento.vue?vue&type=script&lang=js"

import "./InstrucoesCarregamentoPedidoEmAndamento.vue?vue&type=style&index=0&id=c48f9a2e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.goncalves\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c48f9a2e"]])

export default __exports__